const metaNetworksDomains = [
    '.euc.mc.metanetworks.com',
    '.use.mc.metanetworks.com',
    '.usw.mc.metanetworks.com',
    '.ape.mc.metanetworks.com',
];

const vocDomains = {
    prod: ['.voc.ridewithvia.com', '.ridewithvia.com', '.viaforschools.com'],
    dev: ['.voc.dev.ridewithvia.com', '.ridewithvia.com'],
    staging: ['.voc.staging.ridewithvia.com'],
    local: ['localhost:3000']
};

function getMetaNetworksDomain(hostname) {
    return getDomainFromList(hostname, metaNetworksDomains)
}

function getVocDomain(hostname, stage) {
    const stageVocDomains = vocDomains[stage] || [];
    return getDomainFromList(hostname, stageVocDomains)
}

function getDomainFromList(hostname, domainList) {
    for (const domain of domainList) {
        if (hostname.endsWith(domain)) {
            return domain;
        }
    }
    return '';
}

function getDomain(defaultDomainName: string,
                   stage: string,
                   hostname: string = window.location.hostname) {
    const vocDomain = getVocDomain(hostname, stage);
    if(vocDomain) {
        return vocDomain
    } else {
        const metaNetworksDomain = getMetaNetworksDomain(hostname);
        if (metaNetworksDomain) {
            return metaNetworksDomain
        }
    }
    return defaultDomainName;
}

export {getDomain};
